import { BlockProps } from "../../Models";

const StaticContent = ({ section }: BlockProps) => {
    return <p className="mt-5 text-base/normal" dangerouslySetInnerHTML={{ __html: section.content.text || "" }} />;
};

export default StaticContent;
